import React from 'react';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import SnackbarContent from '../../components/Snackbar/SnackbarContent';
import TratamientoForm from './TratamientoForm';
import api from '../../components/Api/Api';

class TratamientoPage extends React.Component {
  state = {
    pending: true,
    formData: {
      code: '',
      name: '',
      days: ''
    }
  };

  constructor(props) {
    super(props);
    this.tratamientoID = props.match.params.id ? props.match.params.id : null;
    this.errorMsg = '';
  }

  componentDidMount() {
    if (this.tratamientoID) {
      this.queryTratamiento();
    } else {
      this.setState({ pending: false });
    }
  }

  queryTratamiento = () => {
    console.log(`fetching tratamiento with id ${this.tratamientoID}`);
    api('tratamiento/' + this.tratamientoID)
      .then(data => {
        console.log('tratamiento fetched');
        this.setState({ pending: false, formData: data.tratamiento });
      })
      .catch(error => {
        console.log(error);
        this.errorMsg = (
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <SnackbarContent message={'ojoooo'} close color='info' />
            </GridItem>
          </GridContainer>
        );
      });
  };

  render() {
    let formContent = '';
    if (this.state.pending) {
      formContent = <div>Esperando datos...</div>;
    } else {
      formContent = (
        <TratamientoForm
          id={this.tratamientoID}
          code={this.state.formData.code}
          name={this.state.formData.name}
          days={this.state.formData.days}
        />
      );
    }

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='info'>
                <h4 style={{ marginTop: '0', marginBottom: '0' }}>
                  Editar Tratamiento
                </h4>
                <p style={{ marginTop: '0', marginBottom: '0' }}>
                  Completar los datos del tratamiento
                </p>
              </CardHeader>
              <CardBody>
                {this.errorMsg}
                <GridContainer>{formContent}</GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default TratamientoPage;
